export const GET_BACKGROUND_PHOTO_PENDING = 'getBackgroundImageMainPending';
export const GET_BACKGROUND_PHOTO_FULFILLED = 'getBackgroundImageMainFulfilled';
export const GET_BACKGROUND_PHOTO_REJECTED = 'getBackgroundImageMainRejected';
export const CHANGE_COMPONENT = 'changeComponent'
